import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { AmplitudeContext } from './core/amplitude-context';
import useAmplitudeCookies from './core/hooks/useAmplitudeCookies';
const useAmplitude = () => {
  const $ = _c(4);
  const context = useContext(AmplitudeContext);
  const {
    deviceId,
    sessionId
  } = useAmplitudeCookies();
  const t0 = context ? context.amplitude : null;
  let t1;
  if ($[0] !== deviceId || $[1] !== sessionId || $[2] !== t0) {
    t1 = {
      amplitude: t0,
      deviceId,
      sessionId
    };
    $[0] = deviceId;
    $[1] = sessionId;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default useAmplitude;